import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import Pagination from './pagination';
import QuickSearch from './quick-search';
import isEqual from 'lodash/isEqual';

export default Vue.component('overview', {
    template:`
    <div v-bind:id="id" class="block block-rounded">
        <div class="block-header block-header-default">
            <div class="d-flex justify-content-between w-100 py-2">
                <div class="d-flex align-items-center">
                    <button v-for="action in actions" type="button" v-on:click="action.onclick" class="btn btn-sm btn-dual flex-shrink-0 mr-2">
                        <i :class="action.icon"></i>{{ action.title }}
                    </button>
                </div>
                <div class="d-flex align-items-center">
                    <quicksearch v-bind="{ queryParameters: queryParameters, loadingRows: loadingRows, paginationSettings: paginationSettings, placeholder: resources.quickSearch.search }"></quicksearch>
                    <button type="button" v-on:click="toggleAdvancedSearch" class="btn btn-sm btn-dual flex-shrink-0 ml-2">
                        <i class="si si-equalizer mr-2"></i>{{ resources.actions.advancedSearchFilter }}
                    </button>
                </div>
            </div>
        </div>
        <div class="block-content block-content-full">
            <advancedsearch v-bind="{ resources: resources, queryParameters: queryParameters, advancedSearch: advancedSearch }"></advancedsearch>
            <div class="table-responsive">
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <grid v-bind="{ rows: rows, columns: columns, loadingRows: loadingRows, resources: resources, queryParameters: queryParameters, axe: axe }"></grid>
                    <pagination v-bind="{ pagination: pagination, queryParameters: queryParameters, rows: rows, resources: resources, loadingPaginationData: loadingPaginationData }"></pagination>
                </div>
            </div>
        </div>
    </div>
    `,
    components: {
        'pagination': Pagination,
        'quicksearch': QuickSearch
    },
    props:{
        id: String,
        baseUrl: String,
        columns: Array,
        defaultSearchParameters: Object,
        searchParameters: Object,
        resources: Object,
        advancedSearch: Object,
        feedbackMessage: String,
        paginationSettings: Object
    },
    data: function(){
        return {
            axe: axios.create({
                baseURL: this.baseUrl,
                paramsSerializer: function(params) {
                    return qs.stringify(params, { indices: false, allowDots: true, skipNulls: true })
                }
            }),
            cancelToken: axios.CancelToken,
            cancelTokenSource: null,
            pagination: {
                totalRecordCount: 0,
                totalPageCount: 0
            },
            rows:[],
            queryParameters: Object.assign({ }, this.searchParameters),
            lastQueryParameters: null,
            loadingRows: true,
            loadingPaginationData: true,
            actions: this.buildActions()
        };
    },
    methods:{
        performSearch(){
            if(this.cancelTokenSource !== null){
                this.cancelTokenSource.cancel('Operation canceled by user multiple performSearch requests.');
            }
            this.cancelTokenSource = this.cancelToken.source();

            var queryParameters = this.getQueryParameters();
            var lastQueryParameters = this.getLastQueryParameters();
            var getGridData =  this.shouldGetGridData(queryParameters, lastQueryParameters);
            var getPaginationData = this.shouldGetPaginationData(queryParameters, lastQueryParameters);
            
            if(getGridData) {
                this.getGridData(queryParameters);
            }

            if(getPaginationData){
                this.getPaginationData(queryParameters);
            }
        },
        applyAdvancedSearch(){
            this.queryParameters.activeAdvancedSearch = true;
            this.queryParameters.pageNumber = 1;
            this.performSearch();
        },
        resetAdvancedSearch(){
            Object.assign(this.queryParameters, this.defaultSearchParameters);
            //this.queryParameters.activeAdvancedSearch = false;
            this.performSearch();
        },
        performQuickSearch(){
            this.queryParameters.pageNumber = 1;
            this.performSearch();
        },
        toggleAdvancedSearch(){
            this.advancedSearch.visible = !this.advancedSearch.visible;
        },
        /**
         * Retrieves the query parameters. If advanced search is inactive, only quick search values 
         * are filled. Sort and pagination values are allways returned. Otherwise cloned queryParameters
         * is returned with all binded values.
         * @returns OverviewParameters
         */
        getQueryParameters(){
            return this.queryParameters.activeAdvancedSearch ? Object.assign({ }, this.queryParameters) : { 
                    keyword : this.queryParameters.keyword,
                    sortDirection: this.queryParameters.sortDirection,
                    sortField: this.queryParameters.sortField,
                    pageNumber: this.queryParameters.pageNumber,
                    pageSize: this.queryParameters.pageSize
                };
        },
        getLastQueryParameters(){
            return Object.assign({ }, this.lastQueryParameters);
        },

        /**
         * Checks if grid data should be retrieved by comparing the query parameters. 
         * @param {*} queryParameters
         * @param {*} lastQueryParameters
         * @returns true if new GridData should be retrieved, otherwise false.
         */
        shouldGetGridData(queryParameters, lastQueryParameters){
            return !isEqual(queryParameters, lastQueryParameters);
        },
        /**
         * Retrieves the grid data based on the specified query parameters.
         *
         * @param {*} queryParameters
         */
        getGridData(queryParameters){
            var requestParameters = Object.assign({ }, queryParameters);
                            
            this.loadingRows = true;
            this.axe.get('/overviewgriddata', { 
                    params: { parameters: requestParameters },
                    cancelToken: this.cancelTokenSource.token
                }).then((response) => { 
                    this.lastQueryParameters = queryParameters;
                    this.cancelTokenSource = null;
                    this.rows.splice(0);
                    
                    if(response.data.rows !== null && response.data.rows.length > 0){
                        this.rows.splice(0, 0, ...response.data.rows);
                    }
                }).catch((thrown) => {
                    //todo : display notification message with message from resources
                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled', thrown.message);
                    } else {
                        console.log('app error', thrown.message);
                    }
                }).then(() => {
                    this.loadingRows = false;
                    One.helpers(['core-bootstrap-popover', 'core-bootstrap-tooltip'])
                });
        },
        /**
         * Checks if pagination data should be retrieved by comparing the query parameters
         * without pagination and sorting parameters.
         * @param {*} queryParameters
         * @param {*} lastQueryParameters
         * @returns
         */
        shouldGetPaginationData(queryParameters, lastQueryParameters){
            var parameters = Object.assign({ }, queryParameters);
            var lastParameters = Object.assign({ }, lastQueryParameters);

            this.clearParametersForPaginationData(parameters);
            this.clearParametersForPaginationData(lastParameters);

            return !isEqual(parameters, lastParameters);
        },
        /**
         * Deletes pageNumber, sortDirection and sortField properties from query parameters 
         * in order to perform getPaginationData changes comparison.
         * @param {*} parameters
         */
        clearParametersForPaginationData(parameters){
            delete parameters.pageNumber;
            delete parameters.sortDirection;
            delete parameters.sortField;
        },
        /**
         * Retrieves pagination data with the specified query parameters.
         *
         * @param {*} queryParameters
         */
        getPaginationData(queryParameters){
            this.loadingPaginationData = true;
            this.axe.get('/overviewpaginationdata', { 
                    params: { parameters: queryParameters },
                    cancelToken: this.cancelTokenSource.token
                }).then((response) => { 
                    this.pagination.totalPageCount = response.data.totalPageCount;
                    this.pagination.totalRecordCount = response.data.totalRecordCount;
                }).catch((thrown) => {
                    //todo : display notification message with message from resources
                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled', thrown.message);
                    } else {
                        console.log('app error', thrown.message);
                    }
                }).then(() => {
                    this.loadingPaginationData = false;
                });
        },
        /** Displays feedback nofification message */
        displayFeedback(){
            if(this.feedbackMessage !== null && this.feedbackMessage !== '') {
                window.$.notify({ type: 'success', icon: 'fa fa-check mr-1', message: this.feedbackMessage });
            }
        }
    },
    provide: function () {
        return {
            performSearch: this.performSearch,
            performQuickSearch: this.performQuickSearch,
            applyAdvancedSearch: this.applyAdvancedSearch,
            resetAdvancedSearch: this.resetAdvancedSearch,
            toggleAdvancedSearch: this.toggleAdvancedSearch
        }
    },
    created() {
        this.performSearch();
        this.displayFeedback();
    }
});